import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useI18n } from "@/i18n";
import { PageHero } from "@/pages/PageHero";
import { ProductCard } from "@/components/catalog/CatalogCards";
import { QuoteWhatsApp } from "@/components/catalog/QuoteWhatsApp";
import { useSeo } from "@/lib/useSeo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CategoryPage() {
  const { slug } = useParams();
  const { t, lang } = useI18n();
  const [category, setCategory] = useState(null);
  useEffect(() => { setCategory(null); axios.get(`${API}/catalog/categories/${slug}?lang=${lang}`).then((response) => setCategory(response.data)); }, [slug, lang]);
  useSeo({ title: category ? `${category.name} | MB300` : t.catalog.seo.title, description: category?.description || t.catalog.seo.description, image: category?.image_url, path: `/equipements/${slug}` });
  if (!category) return <div className="container-x min-h-screen pt-40" data-testid="category-loading">{t.catalog.loading}</div>;
  return (
    <div data-testid="category-page">
      <PageHero eyebrow="MB300 · by NELVIS FRANCE" title={category.name} text={category.description} image={category.image_url} />
      <section className="container-x pb-28">
        <nav className="mb-8 flex flex-wrap items-center gap-2 text-xs text-[var(--steel-dim)]" aria-label="Breadcrumb"><Link to="/equipements" data-testid="category-breadcrumb-catalog">{t.catalog.title}</Link><ChevronRight className="h-3 w-3" /><span data-testid="category-breadcrumb-current">{category.name}</span></nav>
        <div className="mb-10 flex flex-col gap-5 border-y border-white/10 py-7 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-xs uppercase tracking-[0.16em] text-[var(--steel-dim)]" data-testid="category-product-count">{category.products.length} {t.catalog.products}</p>
          <QuoteWhatsApp itemType="category" itemId={category.id} title={category.name} testIdPrefix={`category-${category.slug}`} />
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {category.products.map((product) => <ProductCard key={product.id} product={product} />)}
        </div>
      </section>
    </div>
  );
}